<div class="autocomplete">
  <p-autoComplete
    #selectAutocomplete
    [suggestions]="(autocompleteValues$ | async) || []"
    scrollHeight="400px"
    [group]="true"
    field="label"
    (completeMethod)="searchConversations($event.query)"
    (onSelect)="onSelectChannel($event)"
    [(ngModel)]="selectedValue"
    [styleClass]="'search-conversations'"
    [panelStyleClass]="'search-conversations-panel'"
    [completeOnFocus]="true"
    [dropdown]="true"
    dropdownIcon="pi pi-search"
  >
    <ng-template let-chat pTemplate="item">
      <div class="autocomplete-item" (click)="removeFocusAutocomplete()">
        <div class="sub-label" *ngIf="chat.sublabel" [title]="chat.sublabel">
          {{ chat.sublabel }}
        </div>
        <div class="label" [title]="chat.label">
          {{ chat.label }}
        </div>
      </div>
    </ng-template></p-autoComplete
  >
</div>
